import './Textarea.scss';
import * as React from 'react';
import { omit } from 'lodash';
import classNames from 'classnames';
export type Props = {
  value?: string;
  name?: string;
  invalid: boolean;
  className?: string;
  focusOnRender: boolean;
  fullWidth: boolean;
};
export default class Textarea extends React.Component<Props> {
  static defaultProps = {
    invalid: false,
    focusOnRender: false,
    fullWidth: false,
  };
  node: HTMLInputElement | undefined | null;
  focus() {
    if (this.node != null) {
      this.node.focus();
    }
  }
  componentDidMount() {
    if (this.props.focusOnRender) {
      this.focus();
    }
  }
  render() {
    const { className, invalid, fullWidth, ...remainingProps } = this.props;
    return (
      <textarea
        ref={(node) => (this.node = node)}
        className={classNames('Textarea', className, {
          'Textarea--invalid': invalid,
          'Textarea--fullWidth': fullWidth,
        })}
        {...omit(remainingProps, 'focusOnRender')}
      ></textarea>
    );
  }
}
